<template>
    <input type="text" class="form-control inputElement" :value="value" :id="'value-'+id" autocomplete="off">  
</template>

<script>
export default {
  name: "TextInput",
  data() {
    return {
      output: {},
      
    };
  },
  props: ["value", "id"]
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/input/TextInput.vue